import { jsx as _jsx } from "react/jsx-runtime";
import { ClassLogo as ClassLogoIcon } from '@class-ui/icons/dist/ClassLogo';
import { Close as CloseIcon } from '@class-ui/icons/dist/Close';
import { Warning as WarningIcon } from '@class-ui/icons/dist/Warning';
export const MuiAlert = () => {
    return {
        defaultProps: {
            iconMapping: {
                success: _jsx(ClassLogoIcon, {}),
                info: _jsx(ClassLogoIcon, {}),
                warning: _jsx(WarningIcon, {}),
                error: _jsx(WarningIcon, {})
            },
            slots: {
                closeIcon: CloseIcon
            }
        },
        styleOverrides: {
            root: {
                '&.MuiAlert-root': {
                    width: '100%',
                    backgroundColor: '#4739E7',
                    color: '#FFF',
                    maxWidth: '400px',
                    padding: '8px',
                    gap: '8px',
                    '& > *': {
                        padding: 0,
                        margin: 0
                    }
                },
                '& .MuiAlert-icon': {
                    '& > .MuiSvgIcon-root': {
                        color: '#FFF'
                    }
                },
                '& .MuiAlert-message': {
                    '& > .MuiAlertTitle-root': {
                        margin: 0
                    }
                },
                '& .MuiAlert-action': {
                    marginLeft: 'auto',
                    '& > .MuiButtonBase-root': {
                        color: '#FFF',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.2)'
                        },
                        // Extra action button(s)
                        '&.MuiButton-root': {
                            margin: '4px 4px 0px 8px',
                            border: '1px solid #FFF'
                        },
                        '&.MuiIconButton-root': {
                            padding: '4px',
                            '& > .MuiSvgIcon-root': {
                                fontSize: '16px'
                            }
                        }
                    }
                }
            }
        }
    };
};
